import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import { ScrollManager } from './ScrollManager';
import { CanonicalManager } from './CanonicalManager';

/** Shared site chrome wrapped around every routed page. */
export function Layout() {
  return (
    <div className="min-h-screen bg-cream">
      <ScrollManager />
      <CanonicalManager />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
